<script>
  import Toggle from "lib/components/Toggle.svelte";
  import { Tooltip } from "paxray-components-svelte";

  export let features;
  export let title = "";
  export let description = "";
  export let settings = [];
</script>

<section class="feature-card">
  <div class="card-heading">
    <h2>{title}</h2>
    <Tooltip text={description} />
  </div>

  <div class="settings-list">
    {#each settings as setting}
      <Toggle
        text={setting[2]}
        active={features[setting[0]][setting[1]]}
        on:change={(event) => {
          const section = setting[0];
          const key = setting[1];
          features = {
            ...features,
            [section]: {
              ...features[section],
              [key]: event.detail,
            },
          };
        }}
      />
    {/each}
  </div>
  <slot name="footer" />
</section>

<style>
  .feature-card {
    border: 1px solid var(--pax-black);
    border-radius: 0.5rem;
    overflow: hidden;
    background: var(--pax-white);
  }

  .card-heading {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    min-height: 3rem;
    padding: 0.75rem 1rem;
    background: var(--pax-black);
    color: var(--pax-white);
  }

  .card-heading h2 {
    margin: 0;
    color: inherit;
    font-size: 1rem;
    font-weight: 400;
  }

  .card-heading :global(.tooltip) {
    color: var(--pax-white);
  }

  .settings-list {
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 0.25rem 0 1rem;
    border-top: 1px solid var(--pax-black);
  }

  .settings-list :global(.toggle_wrapper) {
    padding: 0 1rem;
    border-bottom: 1px solid rgba(28, 28, 32, 0.12);
  }

  .settings-list :global(.toggle_wrapper:hover) {
    background: #f7f7f7;
  }

  .settings-list :global(.toggle_wrapper:last-child) {
    border-bottom: 0;
  }
</style>
